import { twMerge } from 'tailwind-merge';

interface SmallCardProps {
  text: string | React.ReactNode;
  textLeftIcon?: React.ReactNode;
  description?: string | React.ReactNode;
  containerClassName?: string;
  descriptionClassName?: string;
}

export const SmallCard = ({
  text,
  textLeftIcon,
  description,
  containerClassName,
  descriptionClassName,
}: SmallCardProps) => {
  return (
    <div
      className={twMerge(
        'flex flex-col border border-gray-300 rounded-lg px-4 py-3',
        containerClassName
      )}
    >
      <div className="flex items-center gap-2">
        {textLeftIcon}
        <div className="text-md font-medium">{text}</div>
      </div>
      {description && (
        <div
          className={twMerge(
            'mt-0.5 text-sm text-gray-600',
            descriptionClassName
          )}
        >
          {description}
        </div>
      )}
    </div>
  );
};
